import React from 'react'
import PieChart from './PieChart'
import { SiBitcoinsv } from "react-icons/si";
import { SiEthereum } from "react-icons/si";
import { ethers } from "ethers";
import {SiBinance} from "react-icons/si";
import { FaJediOrder } from "react-icons/fa";

const BalanceCard = (props) => {
    // console.log("total balance in balance card",props.totalBalance)
    const sepoliaBalance =  parseFloat(props.Ethbalance);
    
    const bscBalance  = parseFloat(props.bscBalance);

    const erc20TokenBalance = parseFloat(props.dioBalance)
    const ethUsd = props.EthUsd;
    const bnbUsd  =props.BnbUsd;
    const Sepoliausd = sepoliaBalance*ethUsd;
    const bscUsd = bscBalance*bnbUsd;
    
    const totalBalance  =  Sepoliausd + bscUsd ;
    const USDBALANCE = parseFloat(totalBalance).toFixed(2);
    // console.log(" total balamce in balance card",totalBalance)
   
    
    return (
        <div className='bg-white rounded-xl border shadow-md p-8 h-auto  '>

            
                <center>
                <PieChart  />
                </center>
            
            <center>
                <h1 className=' text-3xl mt-4 md:mt-0 overflow-y-hidden'> ${USDBALANCE}</h1>
                <p className=' '>Total Balance</p>
            </center>
            <div className=" border-gray-400 border w-full mt-8" />
            <div className="grid grid-cols-3 justify-between items-center  p-2">
            <SiBinance size={50} color="yellow" />
                <h1 className=' '>BNB</h1>
                <p className=' '>{bscBalance}</p>
            </div>

            <div className=" border-gray-400 border w-full " />
            <div className="grid grid-cols-3 justify-between items-center  p-2">
            <SiEthereum size={50} color="blue" />
                <h1 className=''>ETH</h1>
                <p className=' '>{sepoliaBalance}</p>
            </div>


            <div className=" border-gray-400 border w-full " />
            <div className="grid grid-cols-3 justify-between items-center  p-2">
            <FaJediOrder size={44} color="purple" />
                <h1 className=''>DIO</h1>
                <p className=' '>{erc20TokenBalance}</p>
            </div>
            <div class=" border-gray-400 border w-full" />

        </div>

    )
}

export default BalanceCard